<script setup>
// Replaces ShareProjects.vue in share mode. Project creation, listing, and
// deletion now all live on tvain-share itself (see the "Create" page there) -
// the embedded editor is always opened for one specific existing story from
// here on, so there's no list to show, just the current story's Save/Download
// actions and the bootstrap that loads it from the ?story= URL param.
import { onMounted } from "vue";
import { sanitiseData } from "@/utils/storyData.js";
import ShelfHeader from "./ShelfHeader.vue";

const props = defineProps({
  edit: { type: Object, required: true },
  session: { type: Object, required: true },
  backend: { type: Object, required: true },
});

const emit = defineEmits(["set-story", "close-win", "save-data", "download-data"]);

function saveData() {
  emit("save-data");
}

function downloadData() {
  emit("download-data");
}

function closeWin() {
  emit("close-win");
}

onMounted(async () => {
  if (!props.edit.pendingStoryId) return;

  const id = props.edit.pendingStoryId;
  props.edit.pendingStoryId = null;

  const data = await props.backend.load(props.session.user, id);
  const sanitisedData = sanitiseData(data);

  props.edit.currentProjectId = id;
  props.edit.currentProjectName = sanitisedData.project?.name ?? "";
  emit("set-story", sanitisedData);
});
</script>

<template>
  <div class="basic-window">
    <div class="ui-container">
      <ShelfHeader :title="edit.currentProjectName" @close-win="closeWin()" />
      <div class="ui-sub-container ui-controls">
        <div class="panel-buttons">
          <button title="Save data" class="ui-button ui-button-blue ui-button-medium button-repad" @click="saveData()">
            Save data
          </button>
          <button title="Download data" class="ui-button ui-button-blue ui-button-medium button-repad" @click="downloadData()">
            Download data
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
